export const email_validation_regexp =
  /^\s*\w+([\.+_-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+\s*$/i;

export const DEbirthDateValidator =
  /^(?:0[1-9]|[12]\d|3[01])([\.])(?:0[1-9]|1[012])\1(?:19|20)\d\d$/;
